import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { Option } from '../Select/Select';
import { useAllCountryGroupsQuery } from '../../../services/countries';

type CountryGroupSelectProps = {
  defaultGroup?: number;
  onChange: (groupId: number | undefined) => void;
  disabled?: boolean;
  className?: string;
};

const CountryGroupSelect: React.FC<CountryGroupSelectProps> = ({ defaultGroup, onChange, disabled, className }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useAllCountryGroupsQuery({});

  const options: Option[] = useMemo(
    () => (data?.items || []).map((group: any) => ({ value: String(group.id), label: group.name })),
    [data],
  );

  const selected = useMemo(
    () => options.find(option => option.value === String(defaultGroup)),
    [options, defaultGroup],
  );

  return (
    !isFetching && (
      <Select
        options={options}
        defaultValue={selected}
        onChange={option => {
          const id = option ? parseInt(option.value, 10) : NaN;
          onChange(Number.isNaN(id) ? undefined : id);
        }}
        placeholder={t('general.select')}
        disabled={disabled}
        className={className}
        isSearchable
        isClearable
      />
    )
  );
};

export default CountryGroupSelect;
